import { TransactionApiUrls } from "@/modules/transaction/common/enum";
import type {
  ICardTransfer,
  ICreateCardTransferRequest,
  ISaveAsTemplate,
  IUpdateCardTransferRequest,
} from "@/modules/transaction/common/types";
import type { ICommission, IObject } from "@/shared/common/types";
import { generateQuery, withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const cardTransferApi = createApi({
  reducerPath: "cardTransferApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    createCardTransfer: builder.mutation<string, ICreateCardTransferRequest>(
      withIdempotency<ICreateCardTransferRequest>(
        TransactionApiUrls.CardTransferV2
      )),
    updateCardTransfer: builder.mutation<string, IUpdateCardTransferRequest>({
      query: ({ data, id }) => ({
        url: `${TransactionApiUrls.CardTransferV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
    getCardTransfer: builder.query<ICardTransfer, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TransactionApiUrls.CardTransfer}/${id}`,
      }),
    }),
    getCardTransferCommission: builder.query<ICommission, IObject>({
      query: (data) => {
        const query = generateQuery(data);

        return ({
          url: `${TransactionApiUrls.CardTransferCommission}?${query}`,
        });
      },
    }),
    saveCardTransferAsTemplate: builder.mutation<string, ISaveAsTemplate>({
      query: ({ id, name, idempotencyKey }) => ({
        url: `${TransactionApiUrls.CardTransfer}/${id}/Templates`,
        method: "POST",
        headers: { "Idempotency-Key": idempotencyKey },
        data: { name },
      }),
    }),
  }),
});

export const {
  useCreateCardTransferMutation,
  useUpdateCardTransferMutation,
  useGetCardTransferQuery,
  useLazyGetCardTransferCommissionQuery,
  useSaveCardTransferAsTemplateMutation,
} = cardTransferApi;
